/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeRequestGeoPositionRequest
 */
export interface ChangeRequestGeoPositionRequest {
    /**
     * 
     * @type {number}
     * @memberof ChangeRequestGeoPositionRequest
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeRequestGeoPositionRequest
     */
    lon?: number;
}

/**
 * Check if a given object implements the ChangeRequestGeoPositionRequest interface.
 */
export function instanceOfChangeRequestGeoPositionRequest(value: object): value is ChangeRequestGeoPositionRequest {
    return true;
}

export function ChangeRequestGeoPositionRequestFromJSON(json: any): ChangeRequestGeoPositionRequest {
    return ChangeRequestGeoPositionRequestFromJSONTyped(json, false);
}

export function ChangeRequestGeoPositionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestGeoPositionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
    };
}

export function ChangeRequestGeoPositionRequestToJSON(json: any): ChangeRequestGeoPositionRequest {
    return ChangeRequestGeoPositionRequestToJSONTyped(json, false);
}

export function ChangeRequestGeoPositionRequestToJSONTyped(value?: ChangeRequestGeoPositionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lat': value['lat'],
        'lon': value['lon'],
    };
}

